import { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import ReactPhoneInput from "react-phone-input-2";
import { getCountryCallingCode, getCountries } from "libphonenumber-js";
// css
import './Editprofile.css'
import "react-phone-input-2/lib/style.css";
import userProfile from '../../../Assets/images/user.png'
// custom import
import userManagementService from '../../../Services/UserManagement/UserManagementService';
import showToast from '../../../Utils/Toast/ToastNotification';
import { updateUserField } from '../../../Redux/Slice/Auth/AuthSlice';
import { hideLoader, showLoader } from '../../../Redux/Slice/Loader/loaderSlice';
import { HandleApiError } from '../../../Utils/CommonErrors/HandleApiError';

function getCountryISO(countryCode) {
    return getCountries().find(
        (iso) => getCountryCallingCode(iso) === countryCode.replace("+", "")
    );
}
const Editprofile = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch()

    const [formData, setFormData] = useState({
        first_name: '',
        last_name: '',
        email: '',
        phone_number: '',
        country_code: ''
    });
    const token = useSelector((state) => state.auth?.user?.data?.body?.data?.token)
    const profileData = useSelector((state) => state.auth?.user?.data?.body?.data?.userData);

    const role_name = useSelector((state) => state.auth?.user?.data?.body?.data?.role_name);
    const formattedRole = role_name
        .toLowerCase()               // "super_user"
        .replace(/_/g, "-");        // "super-user"



    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prevData) => ({
            ...prevData,
            [name]: value,
        }));
    }

    const handleUpdate = async () => {
        dispatch(showLoader())

        try {
            const response = await userManagementService.updateUser(profileData.id, formData, token);
            if (response.status === 200) {
                dispatch(updateUserField({
                    first_name: formData.first_name,
                    last_name: formData.last_name,
                    country_code: formData.country_code,
                    phone_number: formData.phone_number
                }))
                showToast("success", "User profile Updated Successfully")
                navigate(-1);
            }
        } catch (error) {
            HandleApiError(error)
        }
        finally {
            dispatch(hideLoader())
        }
    }


    useEffect(() => {
        if (profileData) {
            setFormData({
                first_name: profileData.first_name || '',
                last_name: profileData.last_name || '',
                email: profileData.email || '',
                phone_number: profileData.phone_number || '',
                country_code: profileData.country_code || ''
            });
        }
    }, [profileData]);
    
    return (
        <div>
            <div className='main-inner-block'>
                <div className='content'>
                    <div className='white-box'>
                        <div className='inner-content-blk'>
                            <div className='listing-title-block d-flex justify-content-between pt-0 align-items-center'>
                                <div className='box-listing-title profile_heading'>
                                    Profile Details
                                </div>
                                <div className='searchbar-btn d-flex align-items-center gap-4'>
                                    <div className='text-center mt-3 update-div d-flex align-items-center justify-content-center gap-2'>
                                        <button
                                            type="submit"
                                            className="green-btn editbtn"
                                            onClick={handleUpdate}
                                        >
                                            Update
                                        </button>
                                        <button
                                            type="button"
                                            className="green-btn editbtn"
                                            onClick={() => navigate(-1)}
                                        >
                                            Cancel
                                        </button>
                                    </div>
                                </div>
                            </div>
                            <div className='profile-details-box prof-info d-flex justify-content-between align-items-center gap-4'>
                                <div className='inner-profile-block d-flex gap-3 align-items-center'>
                                    <div className='profile-img'>
                                        <img src={userProfile} alt="profile-pic"></img>
                                    </div>
                                    <div className='user-name'>
                                        {profileData.first_name} {profileData.last_name}
                                        <span className='designation-name edit-blk d-block'>{formattedRole}</span>

                                    </div>
                                </div>
                            </div>
                            <div className='create-user-block edit-block'>
                                <div className='add-project-area '>
                                    <div className='add-project-inner'>
                                        <div className='project-details-section row'>
                                            <div className='add-project-box col-md-4 mb-3 '>
                                                <label
                                                    htmlFor="fullName"
                                                    className="form-label m-0 edit-section"
                                                >
                                                    First Name
                                                </label>
                                                <input
                                                    type="text"
                                                    id="fullName"
                                                    className="form-control"
                                                    name="first_name"
                                                    value={formData.first_name}
                                                    onChange={handleChange}
                                                />
                                            </div>
                                            <div className='add-project-box col-md-4 mb-3'>
                                                <label
                                                    htmlFor="lastName"
                                                    className="form-label m-0 edit-section"
                                                >
                                                    Last Name
                                                </label>
                                                <input
                                                    type="text"
                                                    id="lastName"
                                                    name='last_name'
                                                    className="form-control"
                                                    value={formData.last_name}
                                                    onChange={handleChange}
                                                />
                                            </div>
                                            <div className='add-project-box col-md-4 mb-3'>
                                                <label
                                                    htmlFor="workEmail"
                                                    className="form-label m-0 edit-section"
                                                >
                                                    Work Email
                                                </label>
                                                <input
                                                    type="email"
                                                    id="workEmail"
                                                    name='email'
                                                    className="form-control"
                                                    value={formData.email}
                                                    readOnly
                                                />
                                            </div>

                                            <div className='add-project-box col-md-4 mb-3 telephone-field'>
                                                <label
                                                    htmlFor="contactNo"
                                                    className="form-label m-0 edit-section"

                                                >
                                                    Contact No.
                                                </label>

                                                <ReactPhoneInput
                                                    country={"au"}
                                                    value={
                                                        profileData.country_code + profileData.phone_number
                                                    }
                                                    onChange={(value, country) => {
                                                        let cleanedValue = value.replace(
                                                            new RegExp(`^\\+?${country.dialCode}`),
                                                            ""
                                                        );
                                                        setFormData((prevData) => ({
                                                            ...prevData,
                                                            phone_number: cleanedValue,
                                                            country_code: `+${country.dialCode}`,
                                                        }));
                                                    }}
                                                    inputProps={{
                                                        name: "phone_number",
                                                        autoFocus: false,
                                                    }}
                                                />
                                            </div>

                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Editprofile